const MathJaxConfig = {
  loader: { load: ["input/asciimath"] },

  asciimath: {
    delimiters: [
      ["$", "$"],
      ["`", "`"]
    ]
  },

  options: {
    enableMenu: false,
    renderActions: {
      addMenu: []   // <-- THIS is the key
    }
  },

  svg: {
    fontCache: "none"
  }
};

export default MathJaxConfig;